import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    theme: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event.' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    starttime: {
      validations: []
    },   
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone*',
            mapping: 'telNumber'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Email*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date*',
            mapping: 'eventDate'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type',
            options: [
              { label: 'Full Service' , value: 'Full Service'},
              { label: 'Large Pick Up Order', value: 'Large Pick Up Order'},
              { label: 'Disposable Set Up', value: 'Disposable Set Up'},
              { label: 'Delivery', value: 'Delivery' }
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Start Time',
            options: [
              { label: '6:00AM'  , value: '06:00:00'},
              { label: '6:30AM'  , value: '06:30:00'}, 
              { label: '7:00AM'  , value: '07:00:00'},
              { label: '7:30AM'  , value: '07:30:00'},
              { label: '8:00AM'  , value: '08:00:00'},
              { label: '8:30AM'  , value: '08:30:00'},
              { label: '9:00AM'  , value: '09:00:00'},
              { label: '9:30AM'  , value: '09:30:00'},
              { label: '10:00AM' , value: '10:00:00'},
              { label: '10:30AM' , value: '10:30:00'},
              { label: '11:00AM' , value: '11:00:00'},
              { label: '11:30AM' , value: '11:30:00'},
              { label: '12:00PM' , value: '12:00:00'},
              { label: '12:30PM' , value: '12:30:00'},
              { label: '1:00PM'  , value: '13:00:00'},
              { label: '1:30PM'  , value: '13:30:00'},
              { label: '2:00PM'  , value: '14:00:00'},
              { label: '2:30PM'  , value: '14:30:00'},
              { label: '3:00PM'  , value: '15:00:00'},
              { label: '3:30PM'  , value: '15:30:00'},
              { label: '4:00PM'  , value: '16:00:00'},
              { label: '4:30PM'  , value: '16:30:00'},
              { label: '5:00PM'  , value: '17:00:00'},
              { label: '5:30PM'  , value: '17:30:00'},
              { label: '6:00PM'  , value: '18:00:00'},
              { label: '6:30PM'  , value: '18:30:00'},
              { label: '7:00PM'  , value: '19:00:00'},
              { label: '7:30PM'  , value: '19:30:00'},
              { label: '8:00PM'  , value: '20:00:00'},
              { label: '8:30PM'  , value: '20:30:00'},
              { label: '9:00PM'  , value: '21:00:00'},
              { label: '9:30PM'  , value: '21:30:00'},
              { label: '10:00PM' , value: '22:00:00'}, 
              { label: '10:30PM' , value: '22:30:00'}, 
              { label: '11:00PM' , value: '23:00:00'}, 
              { label: '11:30PM' , value: '23:30:00'}, 
              { label: '12:00AM' , value: '24:00:00'}, 
              { label: '12:30AM' , value: '24:30:00'}, 
              { label: '1:00AM'  , value: '01:00:00'}, 
              { label: '1:30AM'  , value: '01:30:00'}, 
              { label: '2:00AM'  , value: '02:00:00'} 
            ],
            mapping: 'starttime'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Guests',
            mapping: 'plannedguestcount'
          }
        ]
      },   
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Details',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Tuscany Gourmet Market Contact Form',
    formId: '278',
    clientKey: '04E17792-DBB6-4939-B7B3-700A96A2A02F',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/tuscanygourmetmarket/form_structure.js